var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48528 7.48523L7.48528 1.41416C7.48528 0.861877 7.933 0.414162 8.48528 0.414161C9.03757 0.414162 9.48528 0.861877 9.48528 1.41416L9.48528 7.48523L15.5564 7.48523C16.1086 7.48523 16.5563 7.93294 16.5563 8.48523C16.5563 9.03751 16.1086 9.48523 15.5564 9.48523L9.48528 9.48523L9.48528 15.5563C9.48528 16.1086 9.03757 16.5563 8.48528 16.5563C7.933 16.5563 7.48528 16.1086 7.48528 15.5563L7.48528 9.48523L1.41421 9.48523C0.861929 9.48523 0.414214 9.03751 0.414214 8.48523C0.414214 7.93294 0.861929 7.48523 1.41421 7.48523L7.48528 7.48523Z",
    fill: "#A653F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIco);
export default __webpack_public_path__ + "static/media/AddIco.fdff0d77087bcf6b0f6e97a8ab3579ef.svg";
export { ForwardRef as ReactComponent };